const select=(selector,scope=document)=>scope.querySelector(selector);
const selectAll=(selector,scope=document)=>[...scope.querySelectorAll(selector)];

function formatMoney(cents,form){
  const currency=form.dataset.currency||'AUD';
  const locale=form.dataset.locale||document.documentElement.lang||'en-AU';
  try{return new Intl.NumberFormat(locale,{style:'currency',currency}).format(Number(cents||0)/100)}catch(error){return `$${(Number(cents||0)/100).toFixed(2)}`}
}

function initSocietyForm(form){
  if(form.dataset.societyReady)return;
  const json=select('[data-society-variants]',form.closest('[data-society-card]'));
  if(!json)return;
  let variants;
  try{variants=JSON.parse(json.textContent)}catch(error){console.error('Unable to read Society variant data.',error);return}
  form.dataset.societyReady='true';
  const optionGroups=selectAll('[data-society-option]',form);
  const planSelect=select('[data-society-plan]',form);
  const variantInput=select('[data-society-variant-id]',form);
  const price=select('[data-society-price]',form);
  const compare=select('[data-society-compare]',form);
  const frequency=select('[data-society-frequency]',form);
  const button=select('[data-society-submit]',form);
  const buttonLabel=select('[data-society-button-label]',form);
  const joinLabel=form.dataset.joinLabel||'Join now';
  const requiresPlan=form.dataset.planRequired==='true';

  const selections=()=>optionGroups.map(group=>select('input:checked',group)?.value);
  const planId=()=>planSelect?.value||'';
  const allocationFor=(variant,id)=>id?variant.allocations.find(allocation=>String(allocation.planId)===String(id)):null;
  const canPurchase=(variant,id)=>variant.available&&(!requiresPlan||Boolean(id))&&(!id||Boolean(allocationFor(variant,id)));
  const findVariant=values=>variants.find(variant=>variant.options.every((value,index)=>value===values[index]));

  function refreshChoiceAvailability(){
    const current=selections();
    optionGroups.forEach((group,index)=>{
      selectAll('input[type="radio"]',group).forEach(input=>{
        const trial=[...current];trial[index]=input.value;
        input.disabled=!variants.some(variant=>variant.options.every((value,position)=>value===trial[position])&&canPurchase(variant,planId()));
      });
    });
  }

  function update(){
    const variant=findVariant(selections())||variants[0];
    const allocation=variant?allocationFor(variant,planId()):null;
    const recurring=Boolean(planId());
    const purchasable=Boolean(variant&&canPurchase(variant,planId()));
    if(variantInput&&variant)variantInput.value=variant.id;
    const currentPrice=allocation?.price??variant?.price??0;
    const comparePrice=allocation?.compareAtPrice??variant?.compareAtPrice??0;
    if(price)price.textContent=formatMoney(currentPrice,form);
    if(compare){compare.textContent=formatMoney(comparePrice,form);compare.hidden=!(comparePrice>currentPrice)}
    if(frequency){const selectedName=planSelect.tagName==='SELECT'?planSelect.selectedOptions[0]?.textContent:'';frequency.textContent=recurring?(selectedName||'Recurring membership'):'One-time purchase'}
    if(button)button.disabled=!purchasable;
    if(buttonLabel)buttonLabel.textContent=purchasable?joinLabel:'Unavailable';
    refreshChoiceAvailability();
  }

  optionGroups.forEach(group=>group.addEventListener('change',update));
  planSelect?.addEventListener('change',update);
  update();
}

function initSociety(scope=document){selectAll('[data-society-form]',scope).forEach(initSocietyForm)}
initSociety();
document.addEventListener('shopify:section:load',event=>initSociety(event.target));
